// src/pages/Subscription.js
import React from "react";
import { useTranslation } from "react-i18next";
import { useUser } from "../context/UserProvider";
import { useTheme } from "../context/ThemeContext";

export default function Subscription() {
  const { subscription, basePrivRole } = useUser();
  const { theme: th, isForest } = useTheme();
  const { t } = useTranslation();
  const active = !!subscription?.valid;
  const roleKey = String(basePrivRole || "free").toLowerCase();
  const privileged = ["admin", "manager", "managerplus"].includes(roleKey);

  const fmt = (ms) => {
    const n = Number(ms || 0);
    if (!n) return "-";
    const d = new Date(n);
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}/${mm}/${dd}`;
  };

  const Field = ({ label, value }) => (
    <div className="mb-3 select-none">
      <label className="block text-sm mb-1" style={{ color: isForest ? '#a5d6a7' : th.text.secondary }}>
        {label}
      </label>
      <input
        readOnly
        tabIndex={-1}
        onFocus={(e) => e.target.blur()}
        className="w-full rounded-lg p-2.5 pointer-events-none caret-transparent min-h-[42px]"
        style={{
          backgroundColor: isForest ? 'rgba(15,58,48,0.7)' : th.input.background,
          border: `1px solid ${isForest ? 'rgba(255,255,255,0.08)' : th.input.border}`,
          color: isForest ? '#e8f5e9' : th.text.primary,
        }}
        value={value}
      />
    </div>
  );

  return (
    <div className="max-w-xl pt-2" style={{ color: th.text.primary }}>
      <div
        className="rounded-2xl p-5 md:p-6 shadow-lg"
        style={{
          backgroundColor: isForest ? '#0f3a30' : th.surface.card,
          border: `1px solid ${isForest ? 'rgba(255,255,255,0.12)' : th.surface.cardBorder}`,
          boxShadow: isForest ? '0 4px 12px rgba(0,0,0,0.3)' : `0 4px 12px ${th.shadow.md}`,
        }}
      >
        <h2
          className="text-lg font-semibold mb-4"
          style={{ color: isForest ? '#e8f5e9' : th.text.primary }}
        >
          {t('subscription.title')}
        </h2>
        <Field label={t('subscription.status')} value={active ? t('subscription.active') : t('subscription.inactive')} />
        {!privileged && (
          <>
            <Field label={t('subscription.startDate')} value={fmt(subscription?.startDate)} />
            <Field label={t('subscription.endDate')} value={fmt(subscription?.endDate)} />
          </>
        )}
      </div>
    </div>
  );
}
